import { noInboundOrderCount } from '@/api/inbound.js'
import dayjs from 'dayjs'

const inboundReminder = {
  state: {
    noInboundOrderCount: 0,
    noInboundOrderUpdatedAt: '',
  },

  mutations: {
    SET_NO_INBOUND_ORDER_COUNT: (state, count) => {
      const numericCount = Number(count);
      state.noInboundOrderCount = Number.isInteger(numericCount) && numericCount > 0 ? numericCount : 0;
      state.noInboundOrderUpdatedAt = dayjs().format('YYYY-MM-DD HH:mm:ss');
    },
  },

  actions: {
    GetNoInboundOrderCount({ commit }) {
      return noInboundOrderCount({}).then(({ data }) => {
        commit('SET_NO_INBOUND_ORDER_COUNT', data);
        return data;
      });
    },
  },
};

export default inboundReminder
